import React from 'react';

import { Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { X } from 'lucide-react';
import { useSelectCurrentUser } from 'src/gql';
import { makeStyles } from 'tss-react/mui';

import { RepositoryTrash } from './RepositoryTrash';

interface RepositoryTrashDialogProps {
  onClose: () => void;
  open: boolean;
}

const useStyles = makeStyles()(theme => ({
  closeButton: {
    color: theme.appColors.iconsType,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden',
    padding: 0,
  },
  header: {
    alignItems: 'flex-start',
    display: 'flex',
    flexShrink: 0,
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    padding: theme.spacing(3, 4, 2),
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: theme.spacing(0.5),
  },
  paper: {
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    height: '75vh',
    maxHeight: 'calc(100vh - 64px)',
    maxWidth: 1200,
    width: '90vw',
  },
  subtitle: {
    color: theme.appColors.secondaryType,
  },
  title: {
    fontWeight: 600,
  },
}));

export function RepositoryTrashDialog({
  onClose,
  open,
}: RepositoryTrashDialogProps): JSX.Element | null {
  const { classes } = useStyles();
  const currentUser = useSelectCurrentUser();

  if (!currentUser?.myRepositoryId) return null;

  return (
    <Dialog classes={{ paper: classes.paper }} maxWidth={false} open={open} onClose={onClose}>
      <div className={classes.header}>
        <div className={classes.headerText}>
          <Typography className={classes.title} variant="h4">
            Trash
          </Typography>
          <Typography className={classes.subtitle} variant="body2">
            Items here can be restored or permanently deleted.
          </Typography>
        </div>
        <IconButton aria-label="Close trash" className={classes.closeButton} onClick={onClose}>
          <X size={20} />
        </IconButton>
      </div>
      <DialogContent className={classes.content}>
        <RepositoryTrash repositoryId={currentUser.myRepositoryId} />
      </DialogContent>
    </Dialog>
  );
}
